"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrainingJobList = void 0;
const T = __importStar(require("@microsoft/fast-element"));
require("./template.html");
const client_1 = require("@rws-framework/client");
//@ts-ignore                
let rwsTemplate = T.html `<div class="container-fluid">
  <div class="training-job-list-page">
    <crud-table title="${'trainer.listTitle'.t()}" addText="${'trainer.addJob'.t()}" resource="trainer" searchPlaceholder="${'trainer.searchPlaceholder'.t()}"
      listEndpoint="trainer.index" 
      deleteEndpoint="trainer.delete"
      blockAdd="true" addRoute="/trainer/create" :columns="${x => x.tableColumns}">
    </crud-table>
  </div>
</div>
`;
const styles = null;
const shadowOptions = { "mode": "open" };
let TrainingJobList = class TrainingJobList extends client_1.RWSViewComponent {
    constructor() {
        super(...arguments);
        this.tableColumns = [
            { key: 'jobId', header: 'trainer.jobId'.t() },
            { key: 'modelName', header: 'trainer.modelName'.t() },
            { key: 'trainingType', header: 'trainer.trainingType'.t(), formatter: (value) => this.getTrainingTypeText(value) },
            { key: 'status', header: 'trainer.status'.t(), formatter: (value) => `<span class="badge badge-${this.statusBadge(value)}">${this.getStatusText(value)}</span>` },
            { key: 'updatedAt', header: 'trainer.updatedAt'.t(), formatter: (value) => this.formatDate(value) }
        ];
    }
    getTrainingTypeText(trainingType) {
        switch (trainingType) {
            case 'lora':
                return 'LoRA';
            case 'full':
                return 'Full';
            default:
                return trainingType || '-';
        }
    }
    statusBadge(status) {
        switch (status) {
            case 'completed':
                return 'success';
            case 'training':
            case 'preparing':
            case 'validating':
                return 'primary';
            case 'error':
                return 'danger';
            case 'idle':
            default:
                return 'secondary';
        }
    }
    getStatusText(status) {
        return status || 'Unknown';
    }
    formatDate(dateValue) {
        if (!dateValue)
            return '-';
        return new Date(dateValue).toLocaleString();
    }
};
exports.TrainingJobList = TrainingJobList;
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], TrainingJobList.prototype, "tableColumns", void 0);
exports.TrainingJobList = TrainingJobList = __decorate([
    (0, client_1.RWSView)('training-job-list', null, { template: rwsTemplate, styles, options: { shadowOptions } })
], TrainingJobList);
TrainingJobList.defineComponent();
